/**
 * compare two values and return 'active' string if equal
 */
module.exports = (index: string, current: string) => {
	if (index == current) {
		return 'active';
	}
};
